module.exports = __webpack_public_path__ + "static/8-9c262991ec7246c00977a7c984b1422e.jpg";